import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { StandardTabs } from "../../../../../shared/components/tabs/StandardTabs"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { UserMeetingService } from "../meetingService/page/MeetingService"
import { UserResourceBooking } from "../resourceBookings/pages/UserResourceBookings"
import { UserPurchases } from "../purchases/pages/UserPurchases"
import { useActiveModules } from "../../../../../shared/hooks/useActiveModules"

export function UserUpcomingOrders() {
    const { hasBooking, hasCatering, hasAppPayment } = useActiveModules()
    const { l10n } = useAppLocalization()
    const tabs = []

    if (hasBooking) {
        tabs.push({
            label: l10n.getString("user-nav-item-upcoming-orders-resource-bookings"),
            component: <UserResourceBooking />,
        })
    }
    if (hasCatering) {
        tabs.push({
            label: l10n.getString("user-nav-item-upcoming-orders-meeting-service"),
            component: <UserMeetingService />,
        })
    }
    if (hasAppPayment) {
        tabs.push({
            label: l10n.getString("user-nav-item-upcoming-orders-purchases"),
            component: <UserPurchases />,
        })
    }

    return (
        <>
            <LocalizedStrict id="user-nav-item-upcoming-orders-title" attrs={{ title: true }}>
                <PageHeader page={Page.USER_UPCOMING_ORDERS} title="Upcoming orders" />
            </LocalizedStrict>
            <StandardTabs tabs={tabs} />
        </>
    )
}
